'use client';
import { reportClientError } from '@smiledragon-corp/signoz-core';
import { useEffect } from 'react';

export type ReportBoundaryErrorOptions = {
  source?: 'react-error-boundary' | 'global-error-boundary';
  componentStack?: string;
};

export function useReportBoundaryError(error: Error, options?: ReportBoundaryErrorOptions): void {
  // biome-ignore lint/correctness/useExhaustiveDependencies: 보고는 error 참조가 바뀔 때만 트리거한다
  useEffect(() => {
    reportClientError({
      error,
      source: options?.source ?? 'react-error-boundary',
      componentStack: options?.componentStack,
    });
  }, [error]);
}
